import { HostCoreMessageType } from './host-core-message-type';

export interface HostCoreMessage {
    requestId?: string;
    type: HostCoreMessageType;
}

export type HostCoreRequest = HostCoreMessage;

export interface HostCoreResponse<T> extends HostCoreMessage {
    type: HostCoreMessageType.Response;
    data?: T;
}

export interface HostCoreErrorResponse extends HostCoreRequest {
    type: HostCoreMessageType.Error;
    error: string;
}
